import { action } from 'satcheljs/lib/legacy';
import {
    getGroupListNodesViewStateStore,
    GroupFolderTreeViewState,
} from 'owa-group-left-nav-folders-store';

/*
 * Sets group list node view state
 * @param groupId the smtp address of group
 * @param groupFolderTreeViewState the view state to set
 */
export default action('setGroupListNodeViewState')(function setGroupListNodeViewState(
    groupId: string,
    groupFolderTreeViewState: GroupFolderTreeViewState
): void {
    getGroupListNodesViewStateStore().groupListNodesViewStates.set(
        groupId.toLowerCase(),
        groupFolderTreeViewState
    );
});
